import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { ControlProps } from "@jsonforms/core";
import { useEffect, useState, useRef } from "react";
import { Button } from "../../../../../../shadcn/components/ui/button";

// TODO: Check if we can apply watermark on these images
export const SubPropertyTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const options = uischema?.options?.additionalData || {};
  const [subPropertyTypeList, setSubPropertyTypeList] = useState<any[]>([]);
  const [customError, setCustomError] = useState("");
  const hasMounted = useRef(false);
  const positionRef = useRef<HTMLInputElement>(null);
  const handleClick = (item: any) => {
    const obj = {
      title: item?.title,
      value: item?.value,
    };
    handleChange(path, obj);
  };

  useEffect(() => {
    setSubPropertyTypeList(options[ctx?.core?.data?.propertyType?.value]);
    if (hasMounted.current) {
      {
        handleChange(path, {});
      }
      // This runs only when `value` changes, but not on the first render.
    } else {
      if (!options[ctx?.core?.data?.propertyType?.value]) {
        const [firstKey, firstValue] = Object.entries(options)[0] || [];
        setSubPropertyTypeList(firstValue as any[]);
        // console.log("out");
      }
      hasMounted.current = true; // Mark as mounted after the first render.
    }
  }, [ctx?.core?.data?.propertyType]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return (
    <div ref={positionRef} className="mt-[62px]">
      <p className="font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-4 text-brand-bgBlack uppercase">
        {schema?.title}
      </p>
      <div className="flex flex-wrap gap-y-4 gap-x-[50px] mid:gap-x-[62px] mt-5">
        {subPropertyTypeList?.map((item: any, index) => (
          <Button
            key={`element-${index}`}
            className={`text-brand-bgBlack flex-col mt-2 h-[94px] relative  rounded-none border hover:bg-brand-lightOrange px-2  w-[120px] ${
              data?.value === item?.value ? "bg-brand-lightOrange" : "bg-white"
            }`}
            onClick={() => handleClick(item)}
          >
            <img
              src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${item?.icon}`}
              alt=""
            />
            <p className="font-openSans font-normal mt-1 lg:font-semibold text-web-body-sm leading-4 text-brand-bgBlack max-w-[100px] text-wrap">
              {item?.title}
            </p>
          </Button>
        ))}
      </div>
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  );
};

export default withJsonFormsControlProps(SubPropertyTypeRenderer);
